import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import moment from "moment";
import cx from "classnames";
import _ from "lodash";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Row,
  TabPane,
  Table
} from "reactstrap";

import userImg from "assets/images/user.png";
import dummyImg from "assets/images/dummy-img.png";
import clockIcon from "assets/images/clock-icon.png";
import dummyavatar from "assets/images/verboden/user.png";
import noChallImg from "assets/images/no-chall-found.png";
import timeImg from "assets/images/team-challenges/time.png";
import incArrow from "assets/images/team-challenges/inc-arrow.png";
import userImg2 from "assets/images/team-challenges/three-user.png";
import vectorImg from "assets/images/team-challenges/team-vector2.png";
import * as socketAction from "redux/sockets/action";
import * as loaderAction from "redux/loader/action";
import * as optAction from "redux/opt/action";
import {
  set_barDataLeftPercentage,
  set_barDaysLeftPercentage,
  set_dataViewChallenge,
  set_daysLeftChallenget,
  set_editChallenge,
  set_parcipantsViewChallenge,
  set_prefillFormState,
  set_prefilledFormObject,
  set_uploadedImgName,
  set_uploadedImgUrl,
  set_useTemplate
} from "redux/opt/action";
import Socket from "socket/socket";
import SideBarTabs from "../landingLibrary/sideBarTabs";
import CreateNewChallenge from "./CreateNewChallenge";
import InviteTeammatesModal from "./InviteTeammatesModal";

const TeamChallenges = (props) => {
  const currentDate = moment();
  const dispatch = useDispatch();
  const socket_connected = _.get(props, "socketReducer.socketConnection");
  const allChallenges = _.get(props, "gameReducer.teamChallenges", []);
  const [showInviteButton, setShowInviteButton] = useState(true);
  const [shareLinkModal, setShareLinkModal] = useState(false);
  const [IviteLink, setIviteLink] = useState("");
  const [magicLinkState, setmagicLinkState] = useState(false);
  const current_user = _.get(props, "gameReducer.currentUser");
  const team = _.get(current_user, "team");
  const teamCode = _.get(team, "id");
  const socketReducer = _.get(props, "socketReducer");
  const challangesTemplate = _.get(
    props,
    "gameReducer.gamesData.challenges.templates"
  );
  const challengesParams = _.get(props, "gameReducer.gamesData.challenges");
  const prefilledFormObject = _.get(props, "optReducer.prefilledFormObject");
  const prefillChallengeForm = _.get(props, "optReducer.prefillChallengeForm");

  const [filterChallenges, setFilterChallenges] = useState("active-challenges");
  const [filteredChallenges, setFilteredChallenges] = useState([]);
  const useTemplate = _.get(props, "optReducer.useTemplate");

  const parcipantsViewChallenge = _.get(
    props,
    "optReducer.parcipantsViewChallenge"
  );
  const barDataLeftPercentage = _.get(
    props,
    "optReducer.barDataLeftPercentage"
  );
  const barDaysLeftPercentage = _.get(
    props,
    "optReducer.barDaysLeftPercentage"
  );
  const dataViewChallenge = _.get(props, "optReducer.dataViewChallenge");
  const daysLeftChallenge = _.get(props, "optReducer.daysLeftChallenge");
  const editChallenge = _.get(props, "optReducer.editChallenge");
  const uploadedImgUrl = _.get(props, "optReducer.uploadImgUrl");
  const uploadedImgName = _.get(props, "optReducer.uploadedImgName");

  const [modal, setModal] = useState(false);
  const [getChallengesBit, setGetChallengesBit] = useState(false);
  const [parcipantsUsernames, setParcipantsUsernames] = useState([]);
  const [createNewChallenge, setCreateNewChallenge] = useState(false);
  const invitedPlayers = socketReducer.invitedPlayers;
  let path = props.history.location.pathname;

  const handleOptClick = () => {
    props.setIsLoading(true);
    let data = {
      action: "opt-get",
      team_code: teamCode
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    !_.isEmpty(current_user?.team)
      ? setShowInviteButton(true)
      : setShowInviteButton(false);
  }, [current_user]);

  useEffect(() => {
    return Socket.addListener("opt-get", handle_opt_get, handle_opt_get_error);
  }, []);

  useEffect(() => {
    return Socket.addListener(
      "challenge-get",
      handle_get_challenge,
      create_get_error
    );
  }, [getChallengesBit]);

  const handle_get_challenge = (res) => {
    getChallengesBit && props.setIsLoading(false);
  };
  const create_get_error = (err) => {
    props.setIsLoading(false);
  };

  const handle_opt_get = (res) => {
    if (res) {
      props.set_team_opts(res.team_opts);
      props.setIsLoading(false);
      props.history.push("/outside_team_building");
    }
  };

  const handle_opt_get_error = () => {
    props.setIsLoading(false);
  };

  const handleRemoveImage = () => {
    dispatch(set_uploadedImgName(""));
    dispatch(set_uploadedImgUrl(""));
  };

  const modalToggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    const newArray = invitedPlayers.map((obj) => {
      return {
        display_name: obj.name,
        user_id: obj.Username,
        profile_img: obj.picture
      };
    });
    setParcipantsUsernames(newArray);
  }, [invitedPlayers]);

  const handleCancel = () => {
    dispatch(set_prefilledFormObject({}));
    dispatch(set_prefillFormState(false));
    dispatch(set_editChallenge(false));
    props.history.push("challenges-library");
  };

  const handleEditChallengeBtn = (challenge) => {
    dispatch(set_editChallenge(true));
    dispatch(set_prefillFormState(true));
    const data = challenge ? challenge : dataViewChallenge;
    const prefilledInputValues = {
      includeWeekends: data?.weekends,
      displayType: data?.show_data,
      challengeName: data?.name,
      challengeType: data?.type,
      challengeDiscription: data?.description,
      goalType: data?.goal_type,
      challengeUnit: data?.unit,
      targetGoal: data?.goal,
      startDate: data?.start_date,
      positive: data?.positive,
      end_on_goal: data?.end_on_goal,
      endDate: data?.end_date,
      archived: data?.archived
    };
    dispatch(set_prefilledFormObject(prefilledInputValues));
    props.history.push("/team-challenges/create-new-challenge");
  };

  const updateChallengeEventListner = () =>
    setGetChallengesBit(!getChallengesBit);

  const daysLeftfromStart = (end_date, start_date) => {
    let eventdate = moment(end_date).add(1, "days");
    let todaysdate = moment(start_date);
    if (eventdate.diff(todaysdate, "days") > 0) {
      return eventdate.diff(todaysdate, "days");
    } else {
      return 0;
    }
  };

  const handleViewChallenge = (challenge, type) => {
    const percentageDataBar = (challenge?.current_data / challenge?.goal) * 100;
    const daysLeftfromToday = () => {
      let eventdate = moment(challenge.end_date).add(2, "days");
      let todaysdate = moment();
      if (eventdate.diff(todaysdate, "days") > 0) {
        return eventdate.diff(todaysdate, "days");
      } else {
        return 0;
      }
    };

    const daysLeftfromStart = () => {
      let eventdate = moment(challenge.end_date).add(1, "days");
      let todaysdate = moment(challenge.start_date);
      if (eventdate.diff(todaysdate, "days") > 0) {
        return eventdate.diff(todaysdate, "days");
      } else {
        return 0;
      }
    };

    let percentageDaysBar = 0;

    if (moment() < moment(challenge?.start_date)) {
      percentageDaysBar = 0;
      dispatch(
        set_daysLeftChallenget(
          daysLeftfromStart(
            dataViewChallenge?.end_date,
            dataViewChallenge?.start_date
          )
        )
      );
    } else if (
      moment(challenge?.start_date) <
      moment() <
      moment(challenge?.end_date)
    ) {
      percentageDaysBar =
        ((daysLeftfromStart(currentDate._d, challenge?.start_date) -
          daysLeftfromToday()) /
          daysLeftfromStart(challenge?.end_date, challenge?.start_date)) *
        100;
      dispatch(set_daysLeftChallenget(daysLeftfromToday()));
    } else if (moment(challenge?.end_date < moment())) {
      percentageDaysBar = 99;
      dispatch(set_daysLeftChallenget(0));
    }

    if (percentageDaysBar > 0 && percentageDaysBar < 101) {
      dispatch(set_barDaysLeftPercentage(percentageDaysBar));
    } else if (percentageDaysBar > 100) {
      dispatch(set_barDaysLeftPercentage(percentageDaysBar - 100));
    } else {
      dispatch(set_barDaysLeftPercentage(0));
    }
    if (percentageDataBar > 0) {
      dispatch(set_barDataLeftPercentage(percentageDaysBar));
    } else {
      dispatch(set_barDataLeftPercentage(0));
    }
    dispatch(set_dataViewChallenge(challenge));
    dispatch(set_parcipantsViewChallenge(challenge?.participants));

    let arr = challenge?.participants;
    arr = arr?.filter((item) => item.enabled === true);
    arr = arr?.map((item) => {
      return {
        Username: item?.user_id,
        name: item?.display_name,
        picture: item?.profile_img,
        enabled: item?.enabled,
        data: item?.data,
        latest_entry_ts: item?.latest_entry_ts,
        entries: item?.entries
      };
    });
    props.setInvitedPlayers(arr);

    if (type === "view") {
      props.history.push("/team-challenges/view-challenge");
    } else if (type === "setting-edit-btn") {
      dispatch(set_editChallenge(true));

      handleEditChallengeBtn(challenge);
      props.history.push("/team-challenges/create-new-challenge");
    }
  };
  const handle_challenge_Update_error = () => {
    console.log("error===>>");
  };

  useEffect(() => {
    if (props.history.location.pathname.includes("challenges-library")) {
      dispatch(set_editChallenge(false));
      dispatch(set_useTemplate(false));
    }
    let tempArray = [];
    if (filterChallenges === "future-challenges") {
      tempArray = allChallenges?.filter(
        (item) => !item.archived && moment(item.start_date) > moment()
      );
    }
    if (filterChallenges === "active-challenges" && allChallenges.length > 0) {
      tempArray = allChallenges?.filter(
        (item) =>
          !item.archived &&
          moment(item.start_date) < moment() &&
          moment(item.end_date).isSameOrAfter(moment().format("YYYY-MM-DD"))
      );
    }
    if (filterChallenges === "archived-challenges") {
      tempArray = allChallenges?.filter((item) => item.archived);
    }
    if (filterChallenges === "completed-challenges") {
      tempArray = allChallenges?.filter(
        (item) =>
          !item?.archived &&
          moment(item?.end_date).isBefore(moment().format("YYYY-MM-DD"))
      );
    }
    setFilteredChallenges(tempArray);
  }, [filterChallenges, allChallenges]);

  useEffect(() => {
    return Socket.addListener(
      "challenge-update",
      updateChallengeEventListner,
      handle_challenge_Update_error
    );
  }, []);

  useEffect(() => {
    return Socket.addListener(
      "challenge-create",
      updateChallengeEventListner,
      handle_challenge_Update_error
    );
  }, []);

  useEffect(() => {
    if (socket_connected) {
      let data = {
        action: "challenge-get",
        table: ["teamChallenges"],
        team_code: current_user?.team?.id
      };
      Socket.sendMessage(data);
    }
  }, [socket_connected, getChallengesBit]);

  const handleUseTemplate = () => {
    dispatch(set_uploadedImgUrl(""));
    dispatch(set_uploadedImgName(""));
    dispatch(set_useTemplate(true));
    props.setInvitedPlayers([]);
    dispatch(set_prefillFormState(true));
    const prefilledInputValues = {
      challengeName: challangesTemplate.predefined[0].name,
      challengeType: challangesTemplate.predefined[0].type,
      challengeDiscription: challangesTemplate.predefined[0].description,
      goalType: challangesTemplate.predefined[0].goal_type,
      challengeUnit: challangesTemplate.predefined[0].unit,
      targetGoal: challangesTemplate.predefined[0].goal
    };
    dispatch(set_prefilledFormObject(prefilledInputValues));
    props.history.push("/team-challenges/create-new-challenge");
  };
  const handleCreateNewChallenge = () => {
    handleRemoveImage();
    setCreateNewChallenge(true);
    dispatch(set_editChallenge(false));
    props.setInvitedPlayers([]);
    dispatch(set_prefilledFormObject({}));
    dispatch(set_prefillFormState(false));
    props.history.push("/team-challenges/create-new-challenge");
  };

  return (
    <>
      <InviteTeammatesModal
        editChallenge={editChallenge}
        parcipantsViewChallenge={parcipantsViewChallenge}
        socketReducer={socketReducer}
        current_user={current_user}
        modal={modal}
        modalToggle={modalToggle}
      />
      <Row className="team-ch-row">
        <Col md={1} lg={1} className="p-0">
          <SideBarTabs
            showInviteButton={showInviteButton}
            setShowInviteButton={setShowInviteButton}
            shareLinkModal={shareLinkModal}
            setShareLinkModal={setShareLinkModal}
            IviteLink={IviteLink}
            setIviteLink={setIviteLink}
            magicLinkState={magicLinkState}
            setmagicLinkState={setmagicLinkState}
            current_user={current_user}
            teamCode={current_user?.team?.teamCode}
            handleOptClick={handleOptClick}
          />
        </Col>
        <Col md={11} lg={11}>
          <main
            className={`team-challenges-main ${
              window.location.pathname.includes("create-new-challenge")
                ? "bottom-margin"
                : ""
            }`}
          >
            <section className="team-challenges-box">
              <Container>
                <Row>
                  <Col md={12}>
                    <div className="team-challenges">
                      <Breadcrumb>
                        <BreadcrumbItem onClick={() => props.history.push("/")}>
                          <a href="#">Activity Library </a>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>Challenges</BreadcrumbItem>
                      </Breadcrumb>
                      <h1 className="heading">Team Challenges</h1>
                      <p className="info">
                        Create and run team-wide challenges for more engagement
                        and bonding.{" "}
                      </p>
                      <div className="team-challenges__vector">
                        <img src={vectorImg} alt="" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>

            <section className="team-challenges-cards">
              <Container>
                <div className="team-challenges-cards-wrap">
                  {/* Filter By Status */}
                  {window.location.pathname.includes("challenges-library") && (
                    <div className="team-text">
                      <h2 className="team">Team Challenges</h2>

                      <button
                        onClick={() => {
                          props.history.push(
                            "/team-challenges/challenges-use-Template"
                          );
                        }}
                        className="create-btn"
                      >
                        Create New
                      </button>
                    </div>
                  )}
                  {props.history.location.pathname.includes(
                    "challenges-library"
                  ) && (
                    <>
                      <div>
                        <h6 className="text-status">
                          {challengesParams?.main?.filter_label
                            ? challengesParams?.main?.filter_label
                            : "Filter by status:"}
                        </h6>
                      </div>
                      <div className="team-challenges-tabs">
                        <div className="tabs-div">
                          <div>
                            <button
                              onClick={() =>
                                setFilterChallenges("active-challenges")
                              }
                              className={cx("tab-btn", {
                                active: filterChallenges === "active-challenges"
                              })}
                            >
                              Active
                            </button>
                            <button
                              onClick={() =>
                                setFilterChallenges("completed-challenges")
                              }
                              className={cx("tab-btn", {
                                active:
                                  filterChallenges === "completed-challenges"
                              })}
                            >
                              Completed
                            </button>
                            <button
                              onClick={() =>
                                setFilterChallenges("archived-challenges")
                              }
                              className={cx("tab-btn", {
                                active:
                                  filterChallenges === "archived-challenges"
                              })}
                            >
                              Archived
                            </button>
                            <button
                              onClick={() =>
                                setFilterChallenges("future-challenges")
                              }
                              className={cx("tab-btn", {
                                active: filterChallenges === "future-challenges"
                              })}
                            >
                              Future
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* {challengesComponent === "view-challenge" && ( */}
                  {props.history.location.pathname.includes(
                    "view-challenge"
                  ) && (
                    <div className="challange-content">
                      <div className="d-flex align-items-start w-65">
                        <div className="img-cont">
                          <img
                            className="w-90"
                            src={
                              dataViewChallenge?.challenge_image
                                ? dataViewChallenge?.challenge_image
                                : dummyImg
                            }
                            alt=""
                          />
                        </div>
                        <div className="content-wrap">
                          <span className="status">
                            {moment(dataViewChallenge?.end_date).isBefore(
                              moment().format("YYYY-MM-DD")
                            )
                              ? "Completed"
                              : moment(dataViewChallenge?.start_date) > moment()
                              ? "Future"
                              : "Active"}
                          </span>
                          <h4 className="title">{dataViewChallenge?.name}</h4>
                          <div className="participants">
                            <img src={userImg} alt="" />
                            <img src={userImg} alt="" />
                            <p>
                              {dataViewChallenge?.participants?.length}{" "}
                              Participants
                            </p>
                          </div>
                          <p className="para">
                            {dataViewChallenge?.description
                              ? dataViewChallenge?.description
                              : "View your challenge activity and participants."}
                          </p>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <button
                          onClick={() => {
                            handleCancel();
                          }}
                          className="back-btn"
                        >
                          {challengesParams?.create?.cancel
                            ? challengesParams?.create?.cancel
                            : "Cancel"}
                        </button>
                        <button
                          onClick={() => handleEditChallengeBtn()}
                          className="create-btn"
                        >
                          Edit Challenge
                        </button>
                      </div>
                    </div>
                  )}
                  {/* {challengesComponent === "view-challenge" && (
                   */}
                  {props.history.location.pathname.includes(
                    "view-challenge"
                  ) && (
                    <div className="challange-activity">
                      <p className="text">Challenge Activity</p>
                      <div class="challenge-progress">
                        <div
                          class="challenge-progress-inner"
                          style={{
                            width: `${
                              barDataLeftPercentage === 0
                                ? barDaysLeftPercentage
                                : barDataLeftPercentage
                            }%`
                          }}
                        >
                          {dataViewChallenge?.end_on_goal && (
                            <span className="days-left">
                              {daysLeftChallenge} Days Left
                            </span>
                          )}
                          {dataViewChallenge?.end_on_goal && (
                            <div
                              class="challenge-progress-circle"
                              style={{
                                left: `${
                                  barDaysLeftPercentage === 100
                                    ? barDaysLeftPercentage - 2
                                    : barDaysLeftPercentage
                                }%`
                              }}
                            >
                              <img
                                src={clockIcon}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="steps">
                        {dataViewChallenge?.end_on_goal ? (
                          <p className="step-txt">
                            <span>{dataViewChallenge?.current_data}</span>/
                            <span>{dataViewChallenge?.goal}</span>{" "}
                            {dataViewChallenge?.unit}
                          </p>
                        ) : (
                          <p className="step-txt">
                            <span>{`${daysLeftChallenge} Days Left`}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {challengesComponent === "view-challenge" && ( */}
                  {props.history.location.pathname.includes(
                    "view-challenge"
                  ) && (
                    <TabPane tabId="2">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="mb-0">Challenge Participants</h3>
                        <Button
                          className="invite-teammates-btn"
                          onClick={() => props.setModal(true)}
                        >
                          {editChallenge
                            ? "Edit Teammates"
                            : "Invite Teammates"}
                        </Button>
                      </div>

                      <Table
                        bordered
                        responsive
                        className="ch-part-table"
                        cellPadding="0"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Teammate</th>
                            <th>Last Active</th>
                            <th>Entries</th>
                            <th>Progress</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parcipantsViewChallenge &&
                            parcipantsViewChallenge.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="teammate">
                                    <img
                                      src={
                                        item?.profile_img
                                          ? item?.profile_img
                                          : dummyavatar
                                      }
                                      alt=""
                                    />
                                    <p className="mb-0">{item?.display_name}</p>
                                  </div>
                                </td>
                                <td>
                                  {item?.latest_entry_ts === 0
                                    ? "None"
                                    : moment(
                                        item?.latest_entry_ts * 1000
                                      ).format("MM/DD/YYYY")}
                                </td>
                                <td>{item?.entries ? item?.entries : "0"}</td>
                                <td>
                                  {item.data} ({dataViewChallenge?.unit})
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </TabPane>
                  )}
                  {/* {challengesComponent === "challenges-use-Template" && ( */}

                  {path.includes("challenges-use-Template") && (
                    <>
                      <div className="challange-content justify-content-between">
                        <div>
                          <h4 className="title">
                            Select Template or Create a New Challenge
                          </h4>
                          <p className="para">
                            Select an existing template or create a new
                            challenge from scratch.{" "}
                          </p>
                        </div>
                        <div>
                          <button
                            onClick={() =>
                              props.history.push(
                                "/team-challenges/challenges-library"
                              )
                            }
                            className="back-btn"
                          >
                            Back
                          </button>
                          <button
                            onClick={() => {
                              handleCreateNewChallenge();
                            }}
                            className="create-btn"
                          >
                            Create New
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {/* {challengesComponent === "challenges-use-Template" && ( */}
                  {props.history.location.pathname.includes(
                    "challenges-use-Template"
                  ) && (
                    <Row>
                      <Col md={6}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="team-challenges-card-new"
                          onClick={() => {
                            handleUseTemplate();
                          }}
                        >
                          <div className="card-flex">
                            <div className="image">
                              <img
                                src={dummyImg}
                                className="img-fluid"
                                alt="dummyImg"
                              />
                            </div>
                            <div className="card-content">
                              <h2 className="ch-name">Challenge Name</h2>
                              <p className="info">
                                You and your friends are invited to be on the
                                world’s hottest new game show,
                              </p>
                              <div className="card-insight">
                                <div className="d-flex align-items-center mr-5">
                                  <img
                                    src={incArrow}
                                    className="img-fluid mr-3"
                                    alt=""
                                  />
                                  <p className="text2">- - -</p>
                                </div>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={timeImg}
                                    className="img-fluid mr-3"
                                    alt=""
                                  />
                                  <p className="text2">Ends - - -</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="challenge-details">
                            <div className="box">
                              <div className="img-box img-box1">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Target Goal</p>
                              <p className="text2">- - -</p>
                            </div>
                            <div className="box">
                              <div className="img-box img-box2">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Current Progress</p>
                              <p className="text2">- - -</p>
                            </div>
                            <div className="box">
                              <div className="img-box img-box3">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Time Left</p>
                              <p className="text2">- - -</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="team-challenges-card-new"
                          onClick={() => {
                            handleUseTemplate();
                          }}
                        >
                          <div className="card-flex">
                            <div className="image">
                              <img
                                src={dummyImg}
                                className="img-fluid"
                                alt="dummyImg"
                              />
                            </div>
                            <div className="card-content">
                              <h2 className="ch-name">Challenge Name</h2>
                              <p className="info">
                                You and your friends are invited to be on the
                                world’s hottest new game show,
                              </p>
                              <div className="card-insight">
                                <div className="d-flex align-items-center mr-5">
                                  <img
                                    src={incArrow}
                                    className="img-fluid mr-3"
                                    alt=""
                                  />
                                  <p className="text2">- - -</p>
                                </div>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={timeImg}
                                    className="img-fluid mr-3"
                                    alt=""
                                  />
                                  <p className="text2">Ends - - -</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="challenge-details">
                            <div className="box">
                              <div className="img-box img-box1">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Target Goal</p>
                              <p className="text2">- - -</p>
                            </div>
                            <div className="box">
                              <div className="img-box img-box2">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Current Progress</p>
                              <p className="text2">- - -</p>
                            </div>
                            <div className="box">
                              <div className="img-box img-box3">
                                <img
                                  src={userImg2}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                              <p className="text1">Time Left</p>
                              <p className="text2">- - -</p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                  {props.history.location.pathname.includes(
                    "challenges-library"
                  ) && filteredChallenges.length > 0 ? (
                    <Row>
                      {filteredChallenges &&
                        filteredChallenges.map((challenge, index) => (
                          <Col key={index} md={6}>
                            <div
                              style={{ cursor: "pointer" }}
                              className="team-challenges-card-new"
                              onClick={() => {
                                handleViewChallenge(
                                  challenge,
                                  "setting-edit-btn"
                                );
                              }}
                            >
                              <div className="card-flex">
                                <div className="image">
                                  <img
                                    src={
                                      challenge?.challenge_image
                                        ? challenge?.challenge_image
                                        : dummyImg
                                    }
                                    className="img-fluid"
                                    alt="dummyImg"
                                  />
                                </div>
                                <div className="card-content">
                                  <h2 className="ch-name">{challenge?.name}</h2>
                                  <p className="info">
                                    {challenge?.description.length > 75
                                      ? challenge?.description.slice(0, 170) +
                                        "..."
                                      : challenge?.description}
                                  </p>
                                  <div className="card-insight">
                                    <div className="d-flex align-items-center mr-5">
                                      <img
                                        src={incArrow}
                                        className="img-fluid"
                                        alt=""
                                      />
                                      <p className="text2">
                                        Highest Average Pushups
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <img
                                        src={timeImg}
                                        className="img-fluid"
                                        alt=""
                                      />
                                      <p className="text2">
                                        Ends {challenge?.end_date.slice(0, 5)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="challenge-details">
                                <div className="box">
                                  <div className="img-box img-box1">
                                    <img
                                      src={userImg2}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </div>
                                  <p className="text1">Target Goal</p>
                                  <p className="text2">{challenge?.goal}</p>
                                </div>
                                <div className="box">
                                  <div className="img-box img-box2">
                                    <img
                                      src={userImg2}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </div>
                                  <p className="text1">Current Progress</p>
                                  <p className="text2">
                                    {challenge?.current_data}
                                  </p>
                                </div>
                                <div className="box">
                                  <div className="img-box img-box3">
                                    <img
                                      src={userImg2}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </div>
                                  <p className="text1">Time Left</p>
                                  <p className="text2">
                                    {daysLeftfromStart(
                                      challenge?.end_date,
                                      challenge?.start_date
                                    ) === 1 && challenge?.goal
                                      ? "1 Day Left"
                                      : daysLeftfromStart(
                                          challenge?.end_date,
                                          challenge?.start_date
                                        ) > 0 &&
                                        daysLeftfromStart(
                                          challenge?.end_date,
                                          challenge?.start_date
                                        ) !== 1
                                      ? `${daysLeftfromStart(
                                          challenge?.end_date,
                                          challenge?.start_date
                                        )} Days Left`
                                      : "0 Days Left"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                    </Row>
                  ) : (
                    // challengesComponent === "challenges-library" && (
                    props.history.location.pathname.includes(
                      "challenges-library"
                    ) && (
                      <>
                        <div className="no-chall-found">
                          <img src={noChallImg} alt="noChallImg" />
                          <p>
                            No challenges to display. Create a challenge and
                            watch your team soar!
                          </p>
                        </div>
                      </>
                    )
                  )}
                  {/* {challengesComponent === "create-new-challenge" && ( */}
                  {props.history.location.pathname.includes(
                    "create-new-challenge"
                  ) && (
                    <CreateNewChallenge
                      history={props?.history}
                      handleRemoveImage={handleRemoveImage}
                      uploadedImgName={uploadedImgName}
                      uploadedImgUrl={uploadedImgUrl}
                      challengesParams={challengesParams}
                      createNewChallenge={createNewChallenge}
                      useTemplate={useTemplate}
                      dataViewChallenge={dataViewChallenge}
                      editChallenge={editChallenge}
                      setFilterChallenges={setFilterChallenges}
                      prefilledFormObject={prefilledFormObject}
                      prefillChallengeForm={prefillChallengeForm}
                      socketReducer={socketReducer}
                      parcipantsUsernames={parcipantsUsernames}
                      setModal={setModal}
                      current_user={current_user}
                    />
                  )}
                </div>
              </Container>
            </section>
          </main>
        </Col>
      </Row>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setChallengesComponent: (data) =>
      dispatch(socketAction.setChallengesComponent(data)),
    setInvitedPlayers: (data) => dispatch(socketAction.setInvitedPlayers(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    set_team_opts: (data) => dispatch(optAction.set_team_opts(data))
  };
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  optReducer: state.optReducer,
  socketReducer: state.socketReducer
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TeamChallenges);
